import apiRequest from '@libs/apiRequest';
import { getFormValues } from 'redux-form';
import { call, put, select } from 'redux-saga/effects';
import { setLoading, setSnack } from 'utilities/redux.actions';

import { FORM_NAME } from 'employee/Employee/common';
import {
    flatToGeneralInfo,
    buildChangeRequestFormData,
    pruneUnchangedLists
} from '../mappers';

/**
 * Final submit of the reused employee wizard when it is driven by the profile
 * change-request page. Reads the shared 'employee' form, builds the general-
 * info multipart payload (files included) and posts it as a change request.
 * `handleComplete` comes from the wizard's stepper so it can advance to the
 * Complete step on success (or stay put on failure).
 */
export default function* (action) {
    const { payload: { handleComplete = () => {}, email, note, initialFlat } = {} } = action;

    yield put(setLoading(true));
    const flat = yield select(getFormValues(FORM_NAME));
    const nested = flatToGeneralInfo(flat || {});
    // Drop list sections the user didn't actually change (avoids false-positive
    // "changed" rows from the round-trip reshaping of repeating lists).
    if (initialFlat) {
        pruneUnchangedLists(nested, flatToGeneralInfo(initialFlat));
    }
    const formData = buildChangeRequestFormData(nested, note, email);

    try {
        const { data } = yield call(apiRequest, {
            url: 'profile-change-request/apply',
            method: 'post',
            data: formData
        });
        yield put(setLoading(false));
        yield put(
            setSnack({
                message:
                    data?.mode === 'applied'
                        ? 'Information updated successfully'
                        : 'Change request submitted for review',
                type: 'success'
            })
        );
        handleComplete({ error: false });
    } catch (error) {
        yield put(setLoading(false));
        yield put(
            setSnack({
                message: error?.response?.data?.message || error?.message,
                type: 'error'
            })
        );
        handleComplete({ error: true });
    }
}
